export { default } from './BancoDoAuto25BannerAbr26';
